var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3747 4.47506L6.31895 15.5308C6.27631 15.5734 6.24173 15.6234 6.21689 15.6784L5.05024 18.2593C4.86037 18.6793 5.29176 19.1107 5.71181 18.9208L8.29267 17.7542C8.34762 17.7293 8.39762 17.6948 8.44026 17.6521L19.496 6.59638C19.6913 6.40112 19.6913 6.08454 19.496 5.88927L18.0818 4.47506C17.8865 4.2798 17.57 4.2798 17.3747 4.47506ZM5.25829 14.4701C5.08772 14.6407 4.94941 14.8407 4.85005 15.0605L3.6834 17.6414C2.92389 19.3216 4.64948 21.0472 6.32969 20.2877L8.91054 19.121C9.13034 19.0217 9.33036 18.8834 9.50092 18.7128L20.5567 7.65704C21.3377 6.87599 21.3377 5.60966 20.5567 4.82861L19.1425 3.4144C18.3614 2.63335 17.0951 2.63335 16.314 3.4144L5.25829 14.4701Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.47 9.53052L14.47 6.53052L15.5307 5.46986L18.5307 8.46986L17.47 9.53052Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.125bebe4.svg";
export { ForwardRef as ReactComponent };